import { storage } from 'BASE/common/util/util.storage';
import { mutationTypes } from 'BASE/store/types'

export default {
    data: function () {
        return {
            betCommonOption: {
                IsFengDanAlert: true,
                IsDrawAlert: true,
                IsWinningAlert: true,
                IsDanTiaoCheck: true,
                IsMilliModeCheck: true,
                IsAwardNotifyAlert: true,
                IsScratchDraw: false,
            },
        };
    },
    methods: {
        openOptionPanel() {
            if (this.$refs.betOptionPanel) {
                this.initBetCommonOption();
                this.$refs.betOptionPanel.openDialog();
            }
        },
        initBetCommonOption() {
            if(this.$store.state.userinfo)
            {
                this.betCommonOption.IsFengDanAlert = this.$store.state.userinfo.alerts.isFengDanEnabled;
                this.betCommonOption.IsDrawAlert = this.$store.state.userinfo.alerts.isDrawEnabled;
                this.betCommonOption.IsWinningAlert = this.$store.state.userinfo.alerts.isWinningEnabled;
            }
            else {
                this.betCommonOption.IsFengDanAlert = true;
                this.betCommonOption.IsDrawAlert = true;
                this.betCommonOption.IsWinningAlert = true;
            }

            this.betCommonOption.IsDanTiaoCheck = storage.local.get(storage.keys.BET_DANTIAO_ENTRY) != false;
            this.betCommonOption.IsMilliModeCheck = storage.local.get(storage.keys.BET_MILLIMODE_ENTRY) != false;
            this.betCommonOption.IsAwardNotifyAlert = storage.local.get(storage.keys.BET_AWARD_NOTIFY_ENTRY) != false;
            this.betCommonOption.IsScratchDraw = storage.local.get(storage.keys.BET_SCRATCH_DRAW_ENTRY) == true;
        },
        async setCommonOption(newOption) {
            try {
                // 封单音效
                if (this.betCommonOption.IsFengDanAlert != newOption.IsFengDanAlert) {
                    await this.setFengDan(newOption.IsFengDanAlert);
                }

                // 开奖音效
                if (this.betCommonOption.IsDrawAlert != newOption.IsDrawAlert) {
                    await this.setDraw(newOption.IsDrawAlert);
                }
                
                // 中奖音效
                if (this.betCommonOption.IsWinningAlert != newOption.IsWinningAlert) {
                    await this.setWinning(newOption.IsWinningAlert);
                }

                // 单挑注单弹窗提示
                if (this.betCommonOption.IsDanTiaoCheck != newOption.IsDanTiaoCheck) {
                    this.setDanTiaoCheck(newOption.IsDanTiaoCheck);
                }

                // 金额分厘模式弹窗提示
                if (this.betCommonOption.IsMilliModeCheck != newOption.IsMilliModeCheck) {
                    this.setMilliModeCheck(newOption.IsMilliModeCheck);
                }

                // 中奖通知弹窗提示
                if (this.betCommonOption.IsAwardNotifyAlert != newOption.IsAwardNotifyAlert) {
                    this.setAwardNotifyAlert(newOption.IsAwardNotifyAlert);
                }

                // 刮刮樂開獎弹窗提示
                if (this.betCommonOption.IsScratchDraw != newOption.IsScratchDraw) {
                    this.setScratchDraw(newOption.IsScratchDraw);
                }
            }
            catch (err) {
                console.log(err);
            }
        },
        async setFengDan(bool) {
            let _respond = await $.post(`/api/AccountCenter/SetFengDanAlert/${!bool}`);
            if (_respond.state) this.$store.commit(mutationTypes.USER_INFO_ALERTS, { isFengDanEnabled: bool });
        },
        async setDraw(bool) {
            let _respond = await $.post(`/api/AccountCenter/SetDrawAlert/${!bool}`);
            if (_respond.state) this.$store.commit(mutationTypes.USER_INFO_ALERTS, { isDrawEnabled: bool });
        },
        async setWinning(bool) {
            let _respond = await $.post(`/api/AccountCenter/SetWinningAlert/${!bool}`);
            if (_respond.state) this.$store.commit(mutationTypes.USER_INFO_ALERTS, { isWinningEnabled: bool });
        },
        setDanTiaoCheck(bool) {
            storage.local.set(storage.keys.BET_DANTIAO_ENTRY, bool);
        },
        setMilliModeCheck(bool) {
            storage.local.set(storage.keys.BET_MILLIMODE_ENTRY, bool);
        },
        setAwardNotifyAlert(bool) {
            storage.local.set(storage.keys.BET_AWARD_NOTIFY_ENTRY, bool);
        },
        setScratchDraw(bool) {
            storage.local.set(storage.keys.BET_SCRATCH_DRAW_ENTRY, bool);
        },
        danTiaoCheckStorage() {
            // 顯示彈窗: null(預設) true, 不顯示彈窗: false
            return storage.local.get(storage.keys.BET_DANTIAO_ENTRY) === false;
        },
        excludeDanTiaoCheckStorage() {
            // 顯示彈窗: null(預設) true, 不顯示彈窗: false
            return storage.local.get(storage.keys.BET_DANTIAO_ENTRY) === false;
        },
        milliModeCheckStorage() {
            // 顯示彈窗: null(預設) true, 不顯示彈窗: false
            return storage.local.get(storage.keys.BET_MILLIMODE_ENTRY) === false;
        },
        excludeMilliModeCheckStorage() {
            // 顯示彈窗: null(預設) true, 不顯示彈窗: false
            return storage.local.get(storage.keys.BET_MILLIMODE_ENTRY) === false;
        },
        awardNotifyAlertStorage() {
            // 顯示彈窗: null(預設) true, 不顯示彈窗: false
            return storage.local.get(storage.keys.BET_AWARD_NOTIFY_ENTRY) === false;
        },
        scratchDrawStorage() {
            // 刮刮樂開獎預設關閉
            return storage.local.get(storage.keys.BET_SCRATCH_DRAW_ENTRY) === true;
        },
    },
}